// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.services {
  padding: 20px;
  margin: 10px;
}

.services h1 {
  font-size: 2.5rem;
  margin-bottom: 20px;
}

.services ul {
  list-style: none;
  padding: 0;
}

.services li {
  font-size: 1.25rem;
  margin-bottom: 10px;
}

.services-page-container,
.service-box {  /* Added .service-box here for common styles */
    display: grid;
    grid-template-columns: 1fr;
    border: 1px solid #ddd;  /* Applying common border styles */
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);  /* Applying common shadow */
    font-family: inherit;
}

.service-box-container {
  display: grid;
  grid-template-columns: 1fr 1fr; /* Two equal columns */
  gap: 20px; /* Adjust if you want different spacing between the boxes */
  justify-content: center; /* This centers the boxes within the grid */
  justify-items: center; /* In case the boxes are smaller than their grid cell, this ensures they're centered within their cell */
}

/* Mobile / Small screen adjustment */
@media (max-width: 768px) {
  .service-box-container {
    grid-template-columns: 1fr; /* Single column layout */
  }
}


/* Medium screens (e.g., larger mobile devices, small tablets) */
@media (min-width: 480px) {
  .services-page-container,
  .service-box {  /* Added .service-box here */
      grid-template-columns: repeat(2, 1fr);
  }
}

/* Larger screens (e.g., tablets in landscape mode, desktops) */
@media (min-width: 768px) {
  .services-page-container {
      grid-template-columns: repeat(3, minmax(calc(33.33% - 20px), 1fr));
  }
}

.rate {
  color: #8d8d8d;
  font-weight: bold;
  margin: 10px;
}

.service-box h3 {
    font-size: 1.5rem;
}

.service-box p,
.service-box li {
    font-size: 1rem;
    margin-bottom: 10px;
}

.consultation-cta {
  text-align: center;
  margin-top: 20px;
}

.consultation-cta a {
  /* background-color: #e04949; */
  color: #f9f9f9;
  padding: 12px 25px;
  font-size: 1.2rem;
  border: none;
  border-radius: 25px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.3s ease;
}

.consultation-cta a:hover {
  /* background-color: #1a1a1a; */
  transform: translateY(-2px);
  box-shadow: 0px 6px 8px rgba(0, 0, 0, 0.15);
}

/* button.link-style {
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  text-decoration: underline;
  cursor: pointer;
}

button.link-style:hover,
button.link-style:focus {
  color: rgb(112, 112, 218);
  text-decoration: none;
}

button.link-style:active {
  color: red;
} */

.service-container {
  max-width: calc(33.33% - 20px); /* This ensures the box will not expand beyond 1/3 of the container minus the gap */
  border: 1px solid #e0e0e0;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin: 20px;
  max-width: 400px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Services.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;gBACgB,8CAA8C;IAC1D,aAAa;IACb,0BAA0B;IAC1B,sBAAsB,GAAG,kCAAkC;IAC3D,2CAA2C,GAAG,2BAA2B;IACzE,oBAAoB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B,EAAE,sBAAsB;EACtD,SAAS,EAAE,2DAA2D;EACtE,uBAAuB,EAAE,2CAA2C;EACpE,qBAAqB,EAAE,wGAAwG;AACjI;;AAEA,qCAAqC;AACrC;EACE;IACE,0BAA0B,EAAE,yBAAyB;EACvD;AACF;;;AAGA,gEAAgE;AAChE;EACE;kBACgB,4BAA4B;MACxC,qCAAqC;EACzC;AACF;;AAEA,+DAA+D;AAC/D;EACE;MACI,kEAAkE;EACtE;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,YAAY;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,eAAe;IACf,mBAAmB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;;;;;;;;;;;;;;;;;GAiBG;;AAEH;EACE,8BAA8B,EAAE,mFAAmF;EACnH,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,wCAAwC;EACxC,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":[".services {\n  padding: 20px;\n  margin: 10px;\n}\n\n.services h1 {\n  font-size: 2.5rem;\n  margin-bottom: 20px;\n}\n\n.services ul {\n  list-style: none;\n  padding: 0;\n}\n\n.services li {\n  font-size: 1.25rem;\n  margin-bottom: 10px;\n}\n\n.services-page-container,\n.service-box {  /* Added .service-box here for common styles */\n    display: grid;\n    grid-template-columns: 1fr;\n    border: 1px solid #ddd;  /* Applying common border styles */\n    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);  /* Applying common shadow */\n    font-family: inherit;\n}\n\n.service-box-container {\n  display: grid;\n  grid-template-columns: 1fr 1fr; /* Two equal columns */\n  gap: 20px; /* Adjust if you want different spacing between the boxes */\n  justify-content: center; /* This centers the boxes within the grid */\n  justify-items: center; /* In case the boxes are smaller than their grid cell, this ensures they're centered within their cell */\n}\n\n/* Mobile / Small screen adjustment */\n@media (max-width: 768px) {\n  .service-box-container {\n    grid-template-columns: 1fr; /* Single column layout */\n  }\n}\n\n\n/* Medium screens (e.g., larger mobile devices, small tablets) */\n@media (min-width: 480px) {\n  .services-page-container,\n  .service-box {  /* Added .service-box here */\n      grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n/* Larger screens (e.g., tablets in landscape mode, desktops) */\n@media (min-width: 768px) {\n  .services-page-container {\n      grid-template-columns: repeat(3, minmax(calc(33.33% - 20px), 1fr));\n  }\n}\n\n.rate {\n  color: #8d8d8d;\n  font-weight: bold;\n  margin: 10px;\n}\n\n.service-box h3 {\n    font-size: 1.5rem;\n}\n\n.service-box p,\n.service-box li {\n    font-size: 1rem;\n    margin-bottom: 10px;\n}\n\n.consultation-cta {\n  text-align: center;\n  margin-top: 20px;\n}\n\n.consultation-cta a {\n  /* background-color: #e04949; */\n  color: #f9f9f9;\n  padding: 12px 25px;\n  font-size: 1.2rem;\n  border: none;\n  border-radius: 25px;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.consultation-cta a:hover {\n  /* background-color: #1a1a1a; */\n  transform: translateY(-2px);\n  box-shadow: 0px 6px 8px rgba(0, 0, 0, 0.15);\n}\n\n/* button.link-style {\n  background: none;\n  border: none;\n  padding: 0;\n  font: inherit;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\nbutton.link-style:hover,\nbutton.link-style:focus {\n  color: rgb(112, 112, 218);\n  text-decoration: none;\n}\n\nbutton.link-style:active {\n  color: red;\n} */\n\n.service-container {\n  max-width: calc(33.33% - 20px); /* This ensures the box will not expand beyond 1/3 of the container minus the gap */\n  border: 1px solid #e0e0e0;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  margin: 20px;\n  max-width: 400px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
